export const LessonsPageNames = {
  PLAN_LESSONS_ROOT: 'PLAN_LESSONS_ROOT',
  LESSON_CREATION_ROOT: 'LESSON_CREATION_ROOT',
  SUMMARY: 'SUMMARY',
  RESOURCE_USER_REPORT: 'RESOURCE_USER_REPORT',
  RESOURCE_USER_REPORT_ROOT: 'RESOURCE_USER_REPORT_ROOT',
  RESOURCE_CONTENT_PREVIEW: 'RESOURCE_CONTENT_PREVIEW', // exclusively a route name
  SELECTION_ROOT: 'SELECTION_ROOT',
  SELECTION: 'SELECTION',
  SELECTION_SEARCH: 'SELECTION_SEARCH',
  SELECTION_CONTENT_PREVIEW: 'SELECTION_CONTENT_PREVIEW', // exclusively a route name
  CONTENT_PREVIEW: 'CONTENT_PREVIEW',
  LESSON_SELECTION_BOOKMARKS: 'LESSON_SELECTION_BOOKMARKS',
  LESSON_SELECTION_BOOKMARKS_MAIN: 'LESSON_SELECTION_BOOKMARKS_MAIN',
};

export const CollectionTypes = {
  LEARNERGROUP: 'learnergroup',
  ADHOCLEARNERSGROUP: 'adhoclearnersgroup',
  CLASSROOM: 'classroom',
};
